import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceindombivali() {



    const cardData = {

keyword: "Cab Service in Dombivli",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Cab Service in Dombivli for local travel, airport transfers, corporate commuting, family outings, and outstation journeys. We provide a fleet of well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus vehicles driven by professional chauffeurs. With 24x7 availability, transparent pricing, instant booking assistance, and doorstep pickup and drop service, we ensure a comfortable, safe, and hassle-free travel experience for customers across Dombivli and surrounding areas.",

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is one of the twelve sacred Jyotirlingas in India and a popular pilgrimage destination from Dombivli. Surrounded by the Sahyadri hills and dense forests, it attracts devotees and nature lovers throughout the year."
    },
    {
        title: "Malshej Ghat",
        description:
            "Malshej Ghat is a scenic mountain pass famous for waterfalls, mist-covered valleys, and breathtaking landscapes. It is one of the most preferred monsoon and weekend getaway destinations from Dombivli."
    },
    {
        title: "Kaas Plateau",
        description:
            "Known as the Valley of Flowers of Maharashtra, Kaas Plateau is a UNESCO World Natural Heritage Site. It becomes vibrant with seasonal wildflowers and offers a unique travel experience for nature enthusiasts."
    },
    {
        title: "Diveagar Beach",
        description:
            "Diveagar is a beautiful Konkan beach destination known for its clean shoreline, peaceful atmosphere, and relaxing coastal charm. It is ideal for family vacations and weekend trips."
    },
    {
        title: "Ratangad Fort",
        description:
            "Ratangad Fort is a historic hill fort located in the Sahyadri mountain range. It is popular among trekkers and adventure travelers looking for scenic views and historical significance."
    },
    {
        title: "Amboli Hill Station",
        description:
            "Amboli is a picturesque hill station in Maharashtra known for lush greenery, waterfalls, and cool weather. It is a perfect destination for nature lovers and monsoon travelers from Dombivli."
    },
    {
        title: "Tuljapur",
        description:
            "Tuljapur is a renowned pilgrimage town famous for the Tulja Bhavani Temple, one of Maharashtra’s most revered spiritual destinations visited by thousands of devotees annually."
    },
    {
        title: "Velas Beach",
        description:
            "Velas is famous for its annual turtle conservation festival and pristine beach environment. It offers a peaceful coastal retreat away from crowded tourist destinations."
    },
    {
        title: "Panhala Fort",
        description:
            "Panhala Fort near Kolhapur is one of Maharashtra’s most significant historical forts. Known for its architecture and connection to Chhatrapati Shivaji Maharaj, it is a favorite destination for history enthusiasts."
    },
    {
        title: "Ujjain Mahakal Darshan",
        description:
            "Ujjain is one of the holiest cities in India and home to the famous Mahakaleshwar Jyotirlinga. It is a popular long-distance pilgrimage destination booked by devotees traveling from Dombivli."
    }
],



services: [
{
name: "Cab Service in Kalyan",
description: "Mumbai Airport Cab provides Cab Service in Kalyan with safe, comfortable, and affordable transportation for local travel, airport transfers, corporate rides, and outstation journeys. We offer AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, and luxury vehicles with professional chauffeurs, 24x7 availability, doorstep pickup, and transparent pricing for smooth travel across Kalyan and nearby areas."
},
{
name: "Kalyan Cab Service",
description: "Kalyan Cab Service offers reliable and timely transportation for daily commuting, family trips, and business travel with clean vehicles and experienced drivers."
},
{
name: "Taxi Service in Kalyan",
description: "Taxi Service in Kalyan ensures safe and comfortable rides across the city with professional chauffeurs, well-maintained cars, and affordable fare options."
},
{
name: "Dombivli Cab Service",
description: "Dombivli Cab Service provides quick and dependable travel solutions for local rides, airport transfers, and outstation trips with smooth and secure transportation."
},
{
name: "Cab Service in Dombivali",
description: "Cab Service in Dombivali offers comfortable and budget-friendly travel options with AC vehicles, professional drivers, and reliable booking support."
},
{
name: "Dombivli Taxi Service",
description: "Dombivli Taxi Service ensures safe city rides, timely pickups, and convenient travel solutions for personal, office, and family transportation needs."
},
{
name: "Kalyan Dombivli Cab Service",
description: "Kalyan Dombivli Cab Service provides complete transportation coverage across both cities with clean cars, experienced chauffeurs, and flexible booking options."
},
{
name: "Local Cab Kalyan Dombivli",
description: "Local Cab Kalyan Dombivli offers fast intra-city rides for shopping, office travel, hospital visits, and daily commuting with affordable pricing."
},
{
name: "Outstation Cab Kalyan Dombivli",
description: "Outstation Cab Kalyan Dombivli provides long-distance travel to destinations like Pune, Nashik, Shirdi, Goa, and more with comfortable vehicles and safe driving."
},
{
name: "24x7 Cab Service Kalyan",
description: "24x7 Cab Service Kalyan ensures round-the-clock availability for airport transfers, emergency travel, night rides, and planned journeys with reliable service."
},
{
name: "24x7 Cab Service Dombivli",
description: "24x7 Cab Service Dombivli provides continuous cab availability for all travel needs with quick response time and professional chauffeurs."
},
{
name: "Affordable Cab Service Kalyan Dombivli",
description: "Affordable Cab Service Kalyan Dombivli offers budget-friendly travel solutions with transparent fares, clean vehicles, and dependable service quality."
},
{
name: "Reliable Cab Service Kalyan Dombivli",
description: "Reliable Cab Service Kalyan Dombivli ensures punctual pickups, verified drivers, GPS-enabled tracking, and consistent travel comfort."
},
{
name: "Kalyan Airport Cab Service",
description: "Kalyan Airport Cab Service provides timely pickup and drop services to Mumbai Airport with flight tracking, luggage assistance, and comfortable rides."
},
{
name: "Dombivli Airport Cab Service",
description: "Dombivli Airport Cab Service ensures smooth airport transfers with professional drivers, clean vehicles, and on-time service for stress-free travel."
},
{
name: "Kalyan City Ride Cab",
description: "Kalyan City Ride Cab offers quick and affordable local travel within Kalyan for office, shopping, and daily commuting needs."
},
{
name: "Dombivli City Ride Cab",
description: "Dombivli City Ride Cab provides convenient intra-city transportation with fast pickup, clean cars, and reliable drivers."
},
{
name: "Kalyan Travel Cab Service",
description: "Kalyan Travel Cab Service offers flexible travel options for local and outstation trips with comfortable vehicles and professional chauffeurs."
},
{
name: "Dombivli Travel Cab Service",
description: "Dombivli Travel Cab Service ensures smooth travel experiences for families and individuals with safe and affordable transportation."
},
{
name: "Kalyan Corporate Cab Service",
description: "Kalyan Corporate Cab Service provides professional transportation for employees, executives, and business travel with punctual and reliable service."
}
],

tableData: [
["Cab Service in Kalyan","Kalyan Cab Service"],
["Taxi Service in Kalyan","Dombivli Cab Service"],
["Cab Service in Dombivali","Dombivli Taxi Service"],
["Kalyan Dombivli Cab Service","Local Cab Kalyan Dombivli"],
["Outstation Cab Kalyan Dombivli","24x7 Cab Service Kalyan"],
["24x7 Cab Service Dombivli","Affordable Cab Service Kalyan Dombivli"],
["Reliable Cab Service Kalyan Dombivli","Kalyan Airport Cab Service"],
["Dombivli Airport Cab Service","Kalyan City Ride Cab"],
["Dombivli City Ride Cab","Kalyan Travel Cab Service"],
["Dombivli Travel Cab Service","Kalyan Corporate Cab Service"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Cab Service in Kalyan",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Cab Services in Kalyan for local travel, airport transfers, outstation journeys, corporate transportation, and daily commuting needs."
    },
    {
        WhyChooseheading: "24x7 Transportation Availability",
        WhyChoosedescription: "Our cab service operates round the clock, helping customers travel conveniently for business meetings, family functions, airport transfers, and emergency travel requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Whether you need transportation within Kalyan or an outstation journey to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, or other destinations, we offer reliable travel options."
    },
    {
        WhyChooseheading: "Wide Fleet of Comfortable Vehicles",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Services",
        WhyChoosedescription: "We provide smooth airport transfers between Kalyan and Mumbai Airport with timely pickups, professional drivers, and comfortable vehicles."
    },
    {
        WhyChooseheading: "Coverage Across Kalyan and Nearby Areas",
        WhyChoosedescription: "Our cab services are available in Kalyan East, Kalyan West, Dombivli, Ulhasnagar, Ambernath, Badlapur, Shahad, Titwala, and surrounding locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and customer satisfaction throughout every journey."
    },
    {
        WhyChooseheading: "Suitable for Families, Tourists, and Corporate Travelers",
        WhyChoosedescription: "From family vacations and local travel to corporate transportation and business meetings, we provide suitable cab solutions for every traveler."
    }
]
};

const faqData = [
    {
        question: "What services are included in Cab Service in Kalyan?",
        answer: "Mumbai Airport Cabs offers local city rides, airport transfers, outstation travel, corporate transportation, sightseeing tours, and customized cab services."
    },
    {
        question: "Can I book a cab from Kalyan to Mumbai Airport?",
        answer: "Yes, airport pickup and drop services are available between Kalyan and Mumbai Airport for domestic and international travelers."
    },
    {
        question: "Which vehicles are available for booking in Kalyan?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        question: "Do you provide outstation cab services from Kalyan?",
        answer: "Yes, outstation cab services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Ahmedabad, Indore, and many other destinations."
    },
    {
        question: "Can corporate clients use your cab service in Kalyan?",
        answer: "Yes, we provide transportation services for corporate offices, executives, employees, business travelers, and corporate events."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, weddings, and group transportation."
    },
    {
        question: "Can I schedule a cab in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure a smooth travel experience."
    },
    {
        question: "Do you provide local sightseeing cabs from Kalyan?",
        answer: "Yes, customers can book cabs for Mumbai Darshan, nearby tourist attractions, shopping trips, and customized travel plans."
    },
    {
        question: "Are your drivers experienced and verified?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local as well as outstation routes."
    },
    {
        question: "How can I book a Cab Service in Kalyan?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pravin Jadhav",
        feedback:
            "I regularly travel from Kalyan to Mumbai Airport and the service has always been reliable. The drivers are punctual, professional, and the vehicles are well-maintained.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Kulkarni",
        feedback:
            "Mumbai Airport Cabs provided excellent transportation for our family trip from Kalyan. The booking process was easy, the cab was comfortable, and the entire journey was hassle-free.",
        rating: 5
    }
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];

















    return (
        <div>









            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceindombivali;